import { Box, Paper, Skeleton, Stack } from '@mui/material';
import React from 'react';

/**
 * Placeholder that mirrors the real blog row's geometry (avatar, topic column,
 * title/date/description stack) so the list doesn't reflow when data lands.
 */
const LoadingBlog: React.FC = () => (
  <Paper elevation={4}>
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <Stack direction="row" spacing={{ xs: 2, sm: 3 }} alignItems="flex-start">
        <Skeleton variant="circular" width={72} height={72} sx={{ flexShrink: 0 }} />

        <Box sx={{ display: { xs: 'none', md: 'block' }, flex: '0 0 auto', width: 116 }}>
          <Stack spacing={0.75}>
            <Skeleton variant="rounded" width={78} height={24} />
            <Skeleton variant="rounded" width={60} height={24} />
          </Stack>
        </Box>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton variant="text" width="45%" height={34} />
          <Skeleton variant="text" width="22%" />
          <Skeleton variant="text" width="90%" />
          <Skeleton variant="text" width="70%" />
        </Box>
      </Stack>
    </Box>
  </Paper>
);

export default LoadingBlog;
